const useEventRegistrationStyles = (backgroundImageUrl, embeddedPreview = false, previewLayout) => {
    const isPreviewMobile = embeddedPreview && previewLayout === 'mobile';
    const isPreviewTablet = embeddedPreview && previewLayout === 'tablet';
    const isPreviewCompact = isPreviewMobile || isPreviewTablet;
    return {
        root: {
            width: '100%',
            position: 'relative',
            display: 'flex',
            ...(embeddedPreview && {
                pt: isPreviewMobile ? 1 : isPreviewTablet ? 1.25 : 1.5,
                px: isPreviewMobile ? 0.5 : isPreviewTablet ? 1 : 1.5,
                boxSizing: 'border-box'
            }),
            ...(backgroundImageUrl && {
                backgroundImage: `url("${backgroundImageUrl}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed'
            })
        },
        content: {
            width: '100%',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            position: 'relative',
            zIndex: 1,
            px: isPreviewMobile
                ? 0.5
                : isPreviewTablet
                    ? 1
                    : embeddedPreview
                        ? { xs: 1, sm: 1.5, md: 2 }
                        : { xs: 1, sm: 1.5, md: 3, lg: 4, xl: 6 },
            pb: isPreviewCompact ? 1 : embeddedPreview ? { xs: 1.5, md: 2.5 } : { xs: 1.5, sm: 2, md: 3, lg: 4 },
            pt: isPreviewMobile
                ? 0
                : isPreviewTablet
                    ? 0.25
                    : embeddedPreview
                        ? { xs: 0.5, sm: 0.75 }
                        : { xs: 1, sm: 1.5, md: 2.5, lg: 3 },
            minHeight: 0,
            overflow: 'hidden',
            boxSizing: 'border-box'
        },
        backgroundVideo: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0
        }
    };
};
export default useEventRegistrationStyles;
